export const isAdapterConfigUsingCustomCaching = adapter => {
  return 'clearCache' in adapter;
};